import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import TableProfileService from './tableProfile.service'
import useAction from '@/hooks/useAction'

const useTableProfile = () => {
  const service = new TableProfileService()
  const baseCrud = useCrud(API_RESOURCE.TABLE_PROFILE, service)
  const queryClient = useQueryClient()

  const useToggleActiveTableProfile = useAction({
    mutationFn: service.toggleActiveTableProfile,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Add profile to all users',
  })

  const useAddProfileToAllUsers = useAction({
    mutationFn: service.addProfileToAllUsers,
    queryKey: baseCrud.queryKey,
    message: 'Successfully Add profile to all users',
  })

  const useUpdateTableProfile = () => {
    return useMutation({
      mutationFn: ({ id, data }) => service.update(id, data),
      onSuccess: (res) => {
        toast.success('Table Profile Updated')
      },
    })
  }

  return {
    useFetchAllTableProfiles: baseCrud.useFetchAll,
    useFetchTableProfile: baseCrud.useFetchOne,
    useCreateTableProfile: baseCrud.useCreate,
    useUpdateTableProfile: useUpdateTableProfile,
    useRemoveTableProfile: baseCrud.useRemove,

    useToggleActiveTableProfile,
    useAddProfileToAllUsers,
  }
}

export default useTableProfile
